'use strict';

module.exports = require('./lib/AsyncEventEmitter');



//////////////////
// WEBPACK FOOTER
// ./~/async-eventemitter/index.js
// module id = 890
// module chunks = 0